import { createStandaloneToast } from '@chakra-ui/react';
import { isRejectedWithValue } from '@reduxjs/toolkit';
import * as Sentry from '@sentry/react';

const { toast } = createStandaloneToast();
/**
 * Log a warning and show a toast!
 */
const rtkQueryErrorLogger = () => (next) => (action) => {
  // RTK Query uses `createAsyncThunk` from redux-toolkit under the hood, so we're able to utilize these matchers!
  if (isRejectedWithValue(action)) {
    console.warn('We got a rejected action!', action);
    const err = new Error(`Api rejected: ${action.payload?.data.error || ''}`);
    err.payload = action.payload;
    err.error = action.error;
    Sentry.captureException(err, {
      extra: {
        payload: action.payload,
        error: action.error,
      },
    });
    const unauthorized = action.payload?.status === 401;
    let message = 'data' in action.error
      ? (action.error.data).message
      : action.error.message;
    if (unauthorized) {
      message = 'You must loggin to continue';
    }
    const id = 'unauthorized-toast';

    if (!toast.isActive(id)) {
      toast({
        id,
        status: 'error',
        title: 'Error!',
        description: message,
        position: 'top-right',
        variant: 'left-accent',
      });
    }
  }

  return next(action);
};

export default rtkQueryErrorLogger;
